/**
 * spiceOnlyViewer — a viewer whose own roster row does SPICE and not care
 * management (whoami.does_spice, whoami.does_care_management). She posts
 * session notes and never keeps the care-management record, so every
 * writing surface shows her its SPICE face with no switch to the
 * care-management one: the client record on a client on both services,
 * the Email helper, the Assessment drafter, and the Home doors into them.
 * Reading surfaces (the notes feed, the record's facts, the Directory)
 * are untouched by this.
 *
 * A viewer with both flags is a care manager who also does SPICE and
 * keeps every switch; so does a viewer with neither.
 */

export function isSpiceOnlyViewer(
  whoami: { does_spice?: boolean | null; does_care_management?: boolean | null } | null | undefined,
): boolean {
  return whoami?.does_spice === true && whoami?.does_care_management !== true;
}
